var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['section.tabs'] = (function () {
    'use strict';

    const initialize = (section) => {
        const dropdown = section.querySelector(".form-select");
        if (!dropdown) return;
        
        // Handle select change show tab
        dropdown.addEventListener("change", function () {
            const value = this.value;
            const activeTabEl = section.querySelector(`[data-bs-target="${value}"]`);
            if (activeTabEl) {
                const tab = new bootstrap.Tab(activeTabEl);
                tab.show();
            }
        });

        // Handle tab shown update select
        section.addEventListener("shown.bs.tab", function () {
            const activeTab = section.querySelector('[data-bs-toggle="tab"].active');
            const activeTarget = activeTab?.getAttribute("data-bs-target");
            if (activeTarget) {
                dropdown.value = activeTarget;
            }
        });
    };

    return {
        initialize
    };

})();